import { useContext, useEffect, useState } from "react";

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  FormControlLabel,
  Grid,
  Switch,
  Tooltip,
} from "@material-ui/core";

import { ExpandMore, Shuffle, PlaylistAddOutlined } from "@material-ui/icons";

import SearchDialog from "../../../../patterns/modals/SearchDialog";
import TextFieldErp from "../../../../components/basics/TextFieldErp";
import SelectErp from "../../../../components/basics/SelectErp";
import Card from "../../../../components/cards/Card";
import useProdutoController from "../controllers/ProdutoController";
import Chip from "../../../../components/basics/Chip";
import { HeaderAccordion, HeaderCard } from "../styles/Produto";
import { ProdutoContext } from "../contexts/ProdutoContext";
import Btn from "../../../../components/buttons/Btn";
import UploadFiles from "../../../../components/uploadFiles/UploadFiles";
import ModalProdutoCodigoBarraAdicional from "./ModalProdutoCodigoBarraAdicional";
import CardProdutoCustoPreco from "./CardProdutoCustoPreco";
import { QueryParamsContext } from "../../../../context/QueryParamsContext";
import SearchSelect from "../../../../components/inputs/SearchSelect";

const columnsNcm = [
  {
    label: "Código",
    id: "ncm",
  },
  {
    label: "NCM",
    id: "descricao",
  },
];

export default function AccordionProdutoPrincipal() {
  const {
    mainProductId,
    mainPhotos,
    setMainPhotos,
    mainActive,
    mainDescription,
    setMainDescription,
    mainManufacturer,
    setMainManufacturer,
    mainBarCode,
    setMainBarCode,
    mainResume,
    setMainResume,
    mainType,
    setMainType,
    mainDepartment,
    setMainDepartment,
    mainSector,
    setMainSector,
    mainGroup,
    setMainGroup,
    mainSubgroup,
    setMainSubgroup,
    mainIcmsEcf,
    setMainIcmsEcf,
    mainNcm,
    setMainNcm,
    mainCest,
    setMainCest,
    mainGtin,
    setMainGtin,
    mainTaxGtin,
    setMainTaxGtin,
    mainStockUnit,
    setMainStockUnit,
    mainSalesUnit,
    setMainSalesUnit,
    mainTaxUnit,
    setMainTaxUnit,
    mainDeliveryUnit,
    setMainDeliveryUnit,
    mainGrossCost,
    setMainGrossCost,
    mainRealCost,
    setMainRealCost,
    mainSalesMargin,
    setMainSalesMargin,
    mainSalePrice,
    setMainSalePrice,
    mainTaxPrice,
    setMainTaxPrice,
    mainConversionFactor,
    setMainConversionFactor,
    taxConversionFactor,
    setTaxConversionFactor,
    mainUseBalance,
    setMainUseBalance,
    fixedPrice,
    setFixedPrice,

    //Códigos de Barras Adicionais
    setBarCodeAdditional,
    barCodeAdditional,

    //Custos e Preços
    mainFreightValue,
    setMainFreightValue,
    mainFreightPercentage,
    setMainFreightPercentage,
    mainInsuranceValue,
    setMainInsuranceValue,
    mainInsurancePercentage,
    setMainInsurancePercentage,
    mainDiscountValue,
    setMainDiscountValue,
    mainDiscountPercentage,
    setMainDiscountPercentage,
    mainOthersValue,
    setMainOthersValue,
    mainOthersPercentage,
    setMainOthersPercentage,
    mainIcmsStValue,
    setMainIcmsStValue,
    mainIcmsStPercentage,
    setMainIcmsStPercentage,
    mainIpiValue,
    setMainIpiValue,
    mainIpiPercentage,
    setMainIpiPercentage,
    mainPisValue,
    setMainPisValue,
    mainPisPercentage,
    setMainPisPercentage,
    mainCofinsValue,
    setMainCofinsValue,
    mainCofinsPercentage,
    setMainCofinsPercentage,
    mainWholesaleValue,
    setMainWholesaleValue,

    listUnits,
    listManufacturer,
    listGroups,
    listSubgroups,
    listDepartments,
    listSectors,
    expanded,
    loadingInputs,
    errors,

    //Ficha Técnica/Comercial
    datasheetQtdPackaging,
    setDatasheetQtdPackaging,
  } = useContext(ProdutoContext);
  const { queryParams } = useContext(QueryParamsContext);
  const {
    handleChangeOpenAcordion,
    handleCreateBarCode,
    handleChoseUnit,
    handleDescribtion,
    handleActiveProduct,
  } = useProdutoController();
  const [openBarCodeAdd, setOpenBarCodeAdd] = useState(false);
  const [searchNcmOpen, setSearchNcmOpen] = useState(false);

  const valuesSettersCard = {
    grossCost: mainGrossCost,
    setGrossCost: setMainGrossCost,
    realCost: mainRealCost,
    setRealCost: setMainRealCost,
    salesMargin: mainSalesMargin,
    setSalesMargin: setMainSalesMargin,
    salePrice: mainSalePrice,
    setSalePrice: setMainSalePrice,
    taxPrice: mainTaxPrice,
    setTaxPrice: setMainTaxPrice,
    freightValue: mainFreightValue,
    setFreightValue: setMainFreightValue,
    freightPercentage: mainFreightPercentage,
    setFreightPercentage: setMainFreightPercentage,
    insuranceValue: mainInsuranceValue,
    setInsuranceValue: setMainInsuranceValue,
    insurancePercentage: mainInsurancePercentage,
    setInsurancePercentage: setMainInsurancePercentage,
    discountValue: mainDiscountValue,
    setDiscountValue: setMainDiscountValue,
    discountPercentage: mainDiscountPercentage,
    setDiscountPercentage: setMainDiscountPercentage,
    othersValue: mainOthersValue,
    setOthersValue: setMainOthersValue,
    othersPercentage: mainOthersPercentage,
    setOthersPercentage: setMainOthersPercentage,
    icmsStValue: mainIcmsStValue,
    setIcmsStValue: setMainIcmsStValue,
    icmsStPercentage: mainIcmsStPercentage,
    setIcmsStPercentage: setMainIcmsStPercentage,
    ipiValue: mainIpiValue,
    setIpiValue: setMainIpiValue,
    ipiPercentage: mainIpiPercentage,
    setIpiPercentage: setMainIpiPercentage,
    pisValue: mainPisValue,
    setPisValue: setMainPisValue,
    pisPercentage: mainPisPercentage,
    setPisPercentage: setMainPisPercentage,
    cofinsValue: mainCofinsValue,
    setCofinsValue: setMainCofinsValue,
    cofinsPercentage: mainCofinsPercentage,
    setCofinsPercentage: setMainCofinsPercentage,
    wholesaleValue: mainWholesaleValue,
    setWholesaleValue: setMainWholesaleValue,
    fixedPrice: fixedPrice,
    setFixedPrice: setFixedPrice,
  };

  const typeList = [
    {
      label: "Revenda",
      id: "R",
    },
    {
      label: "Uso/Consumo Próprio",
      id: "U",
    },
    {
      label: "Insumo",
      id: "I",
    },
    {
      label: "Ativo",
      id: "A",
    },
    {
      label: "Outros",
      id: "O",
    },
  ];

  const handleSelectNcm = (setSearchNcmOpen, selectedNcm) => {
    setSearchNcmOpen(false);

    setMainCest(selectedNcm[0] ? selectedNcm[0].cest : "");
    setMainNcm(selectedNcm[0] || null);
  };

  useEffect(() => {
    setMainCest(mainNcm ? (mainNcm.ncmcest ? mainNcm.ncmcest[0] : null) : null);
  }, [mainNcm, setMainCest]);

  useEffect(() => {
    if (mainBarCode.indexOf(" ") >= 0) {
      setMainBarCode(mainBarCode.replace(" ", ""));
    }
  }, [mainBarCode, setMainBarCode]);

  const precoEstoqueUnico = queryParams.paramprecoestoqueunico === "SIM";

  return (
    <>
      {searchNcmOpen && (
        <SearchDialog
          open={searchNcmOpen}
          setOpen={setSearchNcmOpen}
          columns={columnsNcm}
          selectable={true}
          multiSelect={false}
          handleMainClick={handleSelectNcm}
          route="nf/ncms/v1"
          title="NCM"
        />
      )}

      <ModalProdutoCodigoBarraAdicional
        open={openBarCodeAdd}
        setOpen={setOpenBarCodeAdd}
        barCodeAdditional={barCodeAdditional}
        setBarCodeAdditional={setBarCodeAdditional}
        barCodeFromModal={mainBarCode}
      />
      <Grid item xs={12}>
        <Accordion
          expanded={expanded.main || false}
          onChange={() => handleChangeOpenAcordion("main")}
        >
          <AccordionSummary
            expandIcon={<ExpandMore />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            <HeaderAccordion>
              <Grid container>
                <Grid item xs={12}>
                  <Chip
                    error={!expanded.main && errors.accordionMain}
                    bgcolor={"primary"}
                    textcolor="white"
                    label="DADOS GERAIS"
                  />
                </Grid>
              </Grid>
            </HeaderAccordion>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={2}>
              {mainProductId && (
                <Grid item lg={1} md={1} sm={2} xs={3}>
                  <TextFieldErp
                    label="ID"
                    disabled
                    maxLength={120}
                    value={mainProductId}
                  />
                </Grid>
              )}
              {queryParams.parambuscacodigobarras === "SIM" &&
                queryParams.codigobarraslocalestoque === "NAO" && (
                  <>
                    <Grid
                      item
                      lg={mainProductId ? 3 : 4}
                      md={mainProductId ? 3 : 4}
                      sm={8}
                      xs={12}
                    >
                      <TextFieldErp
                        error={errors.mainBarCode ? true : false}
                        helperText={errors.mainBarCode || ""}
                        label="Código de Barras*"
                        maxLength={120}
                        value={mainBarCode}
                        setValue={setMainBarCode}
                      />
                    </Grid>

                    <Grid item lg={2} md={2} sm={4}>
                      <Grid container spacing={2}>
                        <Grid item xs={6}>
                          <Tooltip title="Gerar Código">
                            <Btn
                              style={{ width: "100%" }}
                              label={<Shuffle />}
                              bgcolor="tertiary"
                              onClick={() =>
                                handleCreateBarCode(setMainBarCode)
                              }
                            />
                          </Tooltip>
                        </Grid>
                        {queryParams.permitecodigobarrasadicionais ===
                          "SIM" && (
                          <Grid item xs={6}>
                            <Tooltip title="Código Adicional">
                              <Btn
                                style={{ width: "100%" }}
                                label={<PlaylistAddOutlined />}
                                bgcolor={
                                  errors.additionalBarCode ? "red" : "tertiary"
                                }
                                onClick={() =>
                                  setOpenBarCodeAdd((current) => !current)
                                }
                              />
                            </Tooltip>
                          </Grid>
                        )}
                      </Grid>
                    </Grid>
                  </>
                )}

              <Grid item lg={6} md={6} sm={12} xs={12}>
                <TextFieldErp
                  error={errors.mainDescription ? true : false}
                  helperText={errors.mainDescription || ""}
                  label="Descrição*"
                  maxLength={120}
                  value={mainDescription}
                  setValue={setMainDescription}
                  onBlur={() => handleDescribtion(mainDescription)}
                />
              </Grid>
              <Grid item lg={4} md={6} sm={6} xs={12}>
                <TextFieldErp
                  error={errors.mainResume ? true : false}
                  helperText={errors.mainResume || ""}
                  label="Descrição Resumida"
                  maxLength={30}
                  value={mainResume}
                  setValue={setMainResume}
                />
              </Grid>
              <Grid item lg={2} md={3} sm={6} xs={12}>
                <SelectErp
                  error={errors.mainManufacturer ? true : false}
                  helperText={errors.mainManufacturer || ""}
                  loading={loadingInputs.listManufacturer || false}
                  label="Fabricante"
                  value={mainManufacturer}
                  setValue={setMainManufacturer}
                  optionsList={listManufacturer}
                  descriptionField="descricao"
                />
              </Grid>

              {queryParams.utilizadepartamentosetor === "SIM" && (
                <>
                  <Grid item lg={2} md={3} sm={6} xs={12}>
                    <SelectErp
                      error={errors.mainDepartment ? true : false}
                      helperText={errors.mainDepartment || ""}
                      loading={loadingInputs.listDepartments || false}
                      label="Departamento"
                      value={mainDepartment}
                      setValue={setMainDepartment}
                      optionsList={listDepartments}
                      descriptionField="descricao"
                    />
                  </Grid>

                  <Grid item lg={2} md={3} sm={6} xs={12}>
                    <SelectErp
                      error={errors.mainSector ? true : false}
                      helperText={errors.mainSector || ""}
                      loading={loadingInputs.listSectors || false}
                      label="Setor"
                      value={mainSector}
                      setValue={setMainSector}
                      optionsList={listSectors}
                      descriptionField="descricao"
                    />
                  </Grid>
                </>
              )}

              <Grid item lg={2} md={3} sm={6} xs={12}>
                <SelectErp
                  error={errors.mainGroup ? true : false}
                  helperText={errors.mainGroup || ""}
                  loading={loadingInputs.listGroups || false}
                  label="Grupo*"
                  value={mainGroup}
                  setValue={setMainGroup}
                  optionsList={listGroups}
                  descriptionField="descricao"
                />
              </Grid>

              <Grid item lg={2} md={3} sm={6} xs={12}>
                <SelectErp
                  error={errors.mainSubgroup ? true : false}
                  helperText={errors.mainSubgroup || ""}
                  loading={loadingInputs.listSubgroups || false}
                  label="Subgrupo*"
                  value={mainSubgroup}
                  setValue={setMainSubgroup}
                  optionsList={listSubgroups}
                  descriptionField="descricao"
                />
              </Grid>
              <Grid item lg={2} md={3} sm={6} xs={12}>
                <SelectErp
                  error={errors.mainType ? true : false}
                  helperText={errors.mainType || ""}
                  // loading={loadingInputs.listType || false}
                  label="Tipo"
                  value={mainType}
                  setValue={setMainType}
                  optionsList={typeList}
                  descriptionField="label"
                />
              </Grid>

              <Grid item lg={3} md={6} sm={6} xs={12}>
                <TextFieldErp
                  error={errors.mainGtin ? true : false}
                  helperText={errors.mainGtin || ""}
                  label="GTIN"
                  maxLength={14}
                  value={mainGtin}
                  setValue={setMainGtin}
                />
              </Grid>

              <Grid item lg={3} md={6} sm={6} xs={12}>
                <TextFieldErp
                  error={!!errors.mainTaxGtin}
                  helperText={errors.mainTaxGtin || ""}
                  label="GTIN Tributável"
                  maxLength={14}
                  value={mainTaxGtin}
                  setValue={setMainTaxGtin}
                />
              </Grid>

              <Grid item lg={2} md={3} sm={6}>
                <SearchSelect
                  descriptionField="ncm"
                  label="NCM"
                  setValue={setMainNcm}
                  route="nf/ncms/v1"
                  filter="ncm"
                  include="ncmcest"
                  error={errors.mainNcm ? true : false}
                  helperText={errors.mainNcm || ""}
                  value={mainNcm ?? ""}
                />
              </Grid>

              <Grid item flex={1}>
                <Btn
                  label="Tributação"
                  bgcolor="tertiary"
                  onClick={() =>
                    window.open(
                      `${
                        queryParams.current_url !== "localhost"
                          ? `https://${queryParams.current_url}.qyon.com/`
                          : "http://localhost/"
                      }zf/dfe/perfil`
                    )
                  }
                  height="48px"
                />
              </Grid>

              <Grid item lg={2} md={3} sm={6} xs={12}>
                <SelectErp
                  loading={loadingInputs.mainNcm || false}
                  label="CEST"
                  value={mainCest}
                  setValue={setMainCest}
                  optionsList={mainNcm ? mainNcm.ncmcest : []}
                  descriptionField="cest"
                />
              </Grid>

              <Grid item lg={2} md={3} sm={6} xs={12}>
                <TextFieldErp
                  error={errors.mainIcmsEcf ? true : false}
                  helperText={errors.mainIcmsEcf || ""}
                  label="ICMS ECF"
                  maxLength={5}
                  value={mainIcmsEcf}
                  setValue={setMainIcmsEcf}
                />
              </Grid>

              <Grid item lg={2} md={4} sm={6} xs={12}>
                <SelectErp
                  error={errors.mainStockUnit ? true : false}
                  helperText={errors.mainStockUnit || ""}
                  loading={loadingInputs.listUnits || false}
                  label="Unidade Estoque*"
                  value={mainStockUnit}
                  setValue={setMainStockUnit}
                  optionsList={listUnits}
                  descriptionField="descricao"
                />
              </Grid>
              <Grid item lg={2} md={4} sm={6} xs={12}>
                <SelectErp
                  error={errors.mainSalesUnit ? true : false}
                  helperText={errors.mainSalesUnit || ""}
                  loading={loadingInputs.listUnits || false}
                  label="Unidade Venda"
                  value={mainSalesUnit}
                  setValue={setMainSalesUnit}
                  optionsList={listUnits}
                  descriptionField="descricao"
                  onChange={handleChoseUnit}
                />
              </Grid>

              {mainStockUnit &&
                mainSalesUnit &&
                mainStockUnit.id !== mainSalesUnit.id && (
                  <Grid item lg={2} md={2} sm={6} xs={12}>
                    <TextFieldErp
                      error={errors.mainConversionFactor ? true : false}
                      helperText={errors.mainConversionFactor || ""}
                      label="Fator de Conversão"
                      maxLength={120}
                      value={mainConversionFactor}
                      setValue={setMainConversionFactor}
                      mask="decimal"
                      decimals={5}
                    />
                  </Grid>
                )}

              <Grid item lg={2} md={4} sm={6} xs={12}>
                <SelectErp
                  error={errors.mainDeliveryUnit ? true : false}
                  helperText={errors.mainDeliveryUnit || ""}
                  loading={loadingInputs.listUnits || false}
                  label="Unidade Entrega"
                  value={mainDeliveryUnit}
                  setValue={setMainDeliveryUnit}
                  optionsList={listUnits}
                  descriptionField="descricao"
                />
              </Grid>

              <Grid item lg={2} md={4} sm={6} xs={12}>
                <SelectErp
                  error={!!errors.mainTaxUnit}
                  helperText={errors.mainTaxUnit || ""}
                  loading={loadingInputs.listUnits || false}
                  label="Unidade Tributável"
                  value={mainTaxUnit}
                  setValue={setMainTaxUnit}
                  optionsList={listUnits}
                  descriptionField="descricao"
                />
              </Grid>

              {mainSalesUnit &&
                mainTaxUnit &&
                mainSalesUnit.id !== mainTaxUnit.id && (
                  <Grid item lg={2} md={2} sm={6} xs={12}>
                    <TextFieldErp
                      error={!!errors.taxConversionFactor}
                      helperText={errors.taxConversionFactor || ""}
                      label="Fator de Conversão Trib"
                      maxLength={120}
                      value={taxConversionFactor}
                      setValue={setTaxConversionFactor}
                      mask="decimal"
                      decimals={5}
                    />
                  </Grid>
                )}

              {/* {queryParams.paramutilizadi === "SIM" && (
                <Grid item lg={2} md={4} sm={6} xs={12}>
                  <TextFieldErp label="DI" maxLength={120} />
                </Grid>
              )} */}

              {queryParams.utilizaembalagemvenda === "SIM" && (
                <Grid item lg={2} md={3} sm={6} xs={12}>
                  <TextFieldErp
                    error={errors.datasheetQtdPackaging ? true : false}
                    helperText={errors.datasheetQtdPackaging || ""}
                    label="Qtd. na Embalagem"
                    maxLength={8}
                    value={datasheetQtdPackaging}
                    setValue={setDatasheetQtdPackaging}
                    mask="decimal"
                  />
                </Grid>
              )}

              {queryParams.paramutilizacodigobalanca === "SIM" && (
                <Grid item flex={1}>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={mainUseBalance}
                        onChange={() =>
                          setMainUseBalance((current) => !current)
                        }
                        color="primary"
                      />
                    }
                    label="Utiliza balança"
                    labelPlacement="end"
                  />
                </Grid>
              )}

              <Grid item flex={1}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={mainActive}
                      onChange={() => handleActiveProduct()}
                      color="primary"
                    />
                  }
                  label="Ativo"
                  labelPlacement="end"
                />
              </Grid>

              <Grid item container spacing={3}>
                <Grid item md={precoEstoqueUnico ? 6 : 12} xs={12}>
                  <Card line="left" lineColor="primary">
                    <HeaderCard>
                      <Grid container>
                        <Chip label="FOTOS" bgcolor="secondary" />
                      </Grid>
                    </HeaderCard>

                    <Grid item xs={12} style={{ marginTop: 20 }}>
                      <UploadFiles
                        main
                        multiple
                        uploadedFiles={mainPhotos}
                        setUploadedFiles={setMainPhotos}
                      />
                    </Grid>
                  </Card>
                </Grid>
                {precoEstoqueUnico && (
                  <Grid item xs={12} md={6} lg={6}>
                    <CardProdutoCustoPreco
                      valuesSetters={valuesSettersCard}
                      accordionMain
                    />
                  </Grid>
                )}
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
      </Grid>
    </>
  );
}
